/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */

export type SsoProviderType = typeof SsoProviderType[keyof typeof SsoProviderType];


export const SsoProviderType = {
  AzureEntraId: 'AzureEntraId',
  AdfsOidc: 'AdfsOidc',
} as const;
